import React, { useEffect, useState } from 'react';
import BackToAction from '../general/backToAction';
import CustomInput from '../general/customInput';
import right_arrow from '../../assets/images/svg/arrow-right.svg';
import { useLocation, useNavigate } from 'react-router-dom';
import CustomCKEditor from '../general/CustomCKEditor';
import InformationContent from '../informationContent';
import leo from 'leo-profanity';
import WarningModal from '../general/warningModal';
import { getData, setData } from '../../utils/storage';
import TopTip from './topTip';
import { templeteData } from '../../data/templeteData';
import ErrorMessage from '../errorMessage';
import { BaseUrl } from '../../config';
import { EmailLogo, EmailTemplateBanner } from '../../config/images';
import EmailModal from '../general/emailModal';
import { ToastContainer, toast } from 'react-toastify';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import htmlToPdfmake from 'html-to-pdfmake';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const TelephoneSupportContainer = () => {

  const navigate = useNavigate();
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);
  const [warning, setWarning] = useState(false);
  const [templateKey, setTemplateKey] = useState('');
  const [emailModal, setEmailModal] = useState(false);
  const [isInformationContentVisible, setIsInformationContentVisible] = useState(false);
    
  //background check questionset
  const [inputs, setInputs] = useState([]);


  useEffect(() => {
    if(location.state !== null && location.state.telephoneKey !== '' && location.state.telephoneKey !== undefined) {
      setInputs(templeteData[location.state.telephoneKey].inputFields)
      setWarning(templeteData[location.state.telephoneKey].warning)
      setTemplateKey(location.state.telephoneKey)
      setIsInformationContentVisible(templeteData[location.state.telephoneKey].information)
    } else {
      getData('telephoneKey').then((res) => {
          if(res !== undefined && res !== '') {
            setInputs(templeteData[res].inputFields)
            setWarning(templeteData[res].warning)
            setTemplateKey(res)
            setIsInformationContentVisible(templeteData[res].information)
          }
        }
      )
    }
  }, [])

  useEffect(() => { }, [
    // outcomeInput, issueInputs,
     inputs,templateKey
  ]);

  useEffect(() => {

    if (location.state !== null && location.state.path === "telephone-prompt") {
      getData('inputFields').then((res) => {
        if (res !== undefined && res.length > 0) {
          setInputs(res);
        }
      }).catch((error) => console.log(error))
      
    }

  }, [])

  const goToPromptsPage = () => {
    let finalArry = inputs;
    let _profinatyCheck = false;
    let updatedData = finalArry.map(obj => {
      let inputValue = obj.type == 'ck-editor' ? leo.check(obj.value.replace(/<[^>]*>/g, '')) : leo.check(obj.value);
      // Check for uppercase words or sentences
      if (obj.type != 'date') {
        // Regular expression to match uppercase words with only alphabets and more than one letter
        const uppercaseWordRegex = /\b[A-Z]{2,}\b/;
        const containsUppercaseWord = uppercaseWordRegex.test(obj.value);

        if (inputValue) {
          _profinatyCheck = true;
          setInputs(prevInputs => prevInputs.map(input => (input.id == obj.id ? { ...input, isValid: false } : input)));
          return { ...obj, isValid: false }
        } else
          if (containsUppercaseWord) {
            _profinatyCheck = true;
            setInputs(prevInputs => prevInputs.map(input => (input.id == obj.id ? { ...input, isValid: false } : input)));
            return { ...obj, isValid: false }
          }
          else {
            setInputs(prevInputs => prevInputs.map(input => (input.id == obj.id ? { ...input, isValid: true } : input)));
            }
        return { ...obj, isValid: true }
      }
    });

    if (_profinatyCheck) {
      setShowModal(true);
      return;
    } else {
      setData('inputFields', inputs);
      setData('telephoneKey', templateKey);
      // setData('issueFields', issueInputs)
      // setData('outComeFields', outcomeInput)
      navigate('/get-advice/telephone-prompts', { state: { data: finalArry, templateType :location.state !== null && location.state.telephoneKey !== undefined ? location.state.telephoneKey : templateKey !== '' ? templateKey : '',isInfo: isInformationContentVisible}  })
    }
  }

  const handleInputChange = (id, newValue) => {
   // this method is used to replace the white background color with the off white color for jodit editor 
   let temp =  newValue.replace(/background-color:\s*rgb\(255,\s*255,\s*255\)/g, 'background-color: rgb(250, 250, 250)');
    
      setInputs(prevInputs =>
        prevInputs.map(input => (input.id === id ? { ...input, value: temp, isValid: newValue != '' } : input))
      );

  };

  const onClose = (e) => {
    setShowModal(false);
  }



  const discardChsnges = () => {
    setInputs(prevInputs => prevInputs.map(input => ({ ...input, value: '' })));
   }

   const LogoImage = `${BaseUrl}/email/Logo.png`;
  const BannerTemplage = `${BaseUrl}/email/template-banner.png`;

const toastMessage = (toastMessage) => {
    toast(toastMessage);

  }


  const htmlContent = `
  <html>
    <head></head>
    <body style="background-color: #fff; font-family: Helvetica, Arial, sans-serif;">
        <div>
            <img width="100" style="width: 100%;" src=${BannerTemplage} alt="banner" />
        </div>
        <table style="width: 95%; padding: 0 1.313rem; margin: 0 auto; display: block;">
            <tr style="display: block; width: 100%" >
                <td style="display: block; margin-top: 1.688rem;">
                    <img src="${LogoImage}" style="width: 10%; min-width: 7rem" alt="TDS Logo" />
                </td>
            </tr>
            <tr style="margin-top: 3.188rem; display: block;">
                <td><p style="min-width: 18.75rem;">Hello,</p></td>
            </tr>
            <tr style="margin-top: 3.188rem;">
                <td>
                    <p style="min-width: 18.75rem;">Thank you for taking the time to visit our support website for people who have issues with their rental property.</p>
                </td>
            </tr>
            <tr>
                <td>
                    <p style="min-width: 18.75rem;">As your recommendation from <a href="#" title="TDS" style="color: inherit; font-weight: 700;">TDS Charitable Foundation</a> was to hold a telephone call to try to resolve your rental issue. You can use these prompts to help frame your telephone conversation.</p>
                </td>
            </tr>
            <tr>
                <td>
                    <p style="min-width: 18.75rem;">We recommend you take additional notes on when the call took place and what was discussed.</p>
                </td>
            </tr>
            <tr>
                <td>
                    <h3 style="font-size: 1rem; line-height: 1.563rem; font-weight: 700; margin-bottom: 1.125rem;">Call to your Landlord</h3>
                </td>
            </tr>
        </table>
        ${Array.isArray(inputs) && inputs.length > 0 ? `
        <table style="width: 95%; margin: 0 auto; padding: 1.313rem; display: block; background-color: #FAFAFA;">
            ${inputs.map(item => `
            <tr style="display: block; margin-bottom: 1rem;">
                <td style="vertical-align: top; display: inline-block; width: 49%; min-width: 9.375rem">
                    <h3 style="font-weight: 700; font-size: 1rem; margin-right: 2.375rem; min-width: 9.25rem; line-height: 1.563rem; margin-top: 0">${item.label}</h3>
                </td>
                <td style="vertical-align: top; display: inline-block; width: 49%; min-width: 9.375rem">
                    <p style="margin: 0">${item.value}</p>
                </td>
            </tr>
            `).join('')}
        </table>
        ` : ''}
        <table style="width: 95%; padding: 0 1.313rem; margin: 1rem auto 3rem; display: block;">
        <tbody style="display: block; width: 100%">
            <tr style="display: block; width: 100%">
                <td style="display: block; margin-top: 1rem;">
                    <p style="margin-bottom: 0">For more information and resources please <a href='https://www.tdsfoundation.org.uk' target="_blank" style="font-weight: bold; text-decoration: underline; color: #3d4852">visit our website.</a></p>
                </td>
            </tr>
            <tr style="display: block; width: 100%">
                <td style="display: block; margin-top: 1rem;">
                    <p style="margin-bottom: 0">Best wishes,</p>
                </td>
            </tr>
            <tr style="display: block; width: 100%">
                <td style="display: block; margin-top: 1rem;">
                    <p style="margin-bottom: 0"><i>My Housing Gateway Team</i></p>
                </td>
            </tr>
            <tr style="display: block; width: 100%">
                <td style="display: block; margin-top: 1.688rem;">
                    <img src="${LogoImage}" style="width: 10%; min-width: 7rem" alt="TDS Logo" />
                </td>
            </tr>
            </tbody>
        </table>
    </body>
  </html>
  `;


  const printContent = `
  <!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "https://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
  <html xmlns="https://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
  <head>
    <style>
      * { 
        margin: 0;
        padding: 0;
      }
      body {
        width: 100%;
        font-size: 1.5vw;
        font-family: Helvetica, Arial, sans-serif;
      }
      h3 {
        font-size: 1.5em;
        font-weight: 700;
        margin-bottom: 1rem;
      }
      p, a {
        font-size: 1.2em;
        margin-top: 0;
      }
      .prompts-container {
        margin: 0 auto;
        padding: 1rem;
        background-color: #FAFAFA !important;
      }
      img {
        width: 100%;
        max-width: 100%;
      }
      @media print {
        .prompts-container {
          background-color: #FAFAFA !important;
        }
      }
    </style>
  </head>
  <body>
    <div style="width: 100%; display: block;">
      <img width="100" style="width: 100%;" src="${EmailTemplateBanner}" alt="banner" />
    </div>
    
    ${Array.isArray(inputs) && inputs.length > 0 ? `
    <div style="width: 95%; margin: 0 auto; padding: 1.313rem; background-color: #FAFAFA;" class="prompts-container">
      ${inputs.map(item => `
      <div style="margin-bottom: 1rem; display: flex; justify-content: space-between; align-items: flex-start;">
        <div style="vertical-align: top; width: 49%;">
          <h3 style="margin-top: 0;">${item.label}</h3>
        </div>
        <div style="vertical-align: top; width: 49%;">
          <p style="margin-bottom: 0;">${item.value}</p>
        </div>
      </div>
      `).join('')}
    </div>
    ` : ''}
    
    </div>
  </body>
</html>
`;

  const isHTML = (str) => {
    const regex = /<\/?[a-z][\s\S]*>/i;
    return regex.test(str);
  };

  const downloadClick = () => {
    // generatePDF(printContent);
    const _content = [


      // Add more content sections as needed
    ];
    if (Array.isArray(inputs) && inputs.length > 0) {

      _content.push({
        table: {
          widths: ['29%', '69%'],
          body: inputs.map(item => {
            let isvalue = item.value.length > 0 ? isHTML(item.value) : false;
            let formatedObjectArry = [];
            if (isvalue) {
              let temp = htmlToPdfmake(item.value, { ignoreStyles: ['font-family', 'font', 'margin'] });

              if (temp.length > 0) {

                temp = temp.map((item) => {

                  if (typeof item.text === 'string') {
                    formatedObjectArry.push({
                      text: item.text + " \n",
                      style: 'dynamicTextStyle',
                      bold: item.hasOwnProperty('bold') ? item.bold : false,
                      nodeName: item.hasOwnProperty('nodeName') ? item.nodeName == 'STRONG' ? item.nodeName : '' : '',
                    })
                    return item;
                  } else if (typeof item.text === 'object') {

                    let _text = {
                      text: [],
                      style: 'dynamicTextStyle',
                      nodeName: '',
                      fontSize: '',
                    };
                    let temptext = item.text.map((item1, index) => {

                      if (item1.text !== '' && item1.text !== ' ') {
                        if (isvalue) {
                          if (index === 0) {
                            _text.text.push(item1);
                          } else {
                            _text.text.push(item1);
                          }
                        }

                        return item1;

                      }
                    });

                    formatedObjectArry.push(_text);

                    return temptext;
                  }
                });

              }
            }
            return [
              { text: item.label, bold: true, alignment: 'left' },
              { text: isvalue ? formatedObjectArry : item.value, alignment: 'left' }
            ]
          }),
        },
        layout: {
          hLineWidth: () => 0,
          vLineWidth: () => 0,
          paddingLeft: () => 20,
          paddingRight: () => 20,
          paddingTop: () => 20,
          paddingBottom: () => 20,
        },
        fillColor: '#FAFAFA',
        margin: [0, 0, 0, 10]
      });
    }
    let letterBottom = [


      {
        text: ['For more information and resources please visit our website.', { text: 'website', bold: true, link: 'http://your-link.com' }],
        style: 'textStyle'
      },
      {
        text: 'Best wishes,',
        style: 'textStyle'
      },
      {
        text: 'My Housing Gateway Team',
        italic: true,
        style: 'textStyle'
      },
      {

        image: EmailLogo, // Base64 encoded image
        width: 100,
        margin: [0, 15, 10, 15] // Adjust margins as needed

      },
    ]

    const docDefinition = {
      pageMargins: [90, 80, 80, 40], // [left, top, right, bottom]
      header: (currentPage, pageCount) => {
        return {
          image: EmailTemplateBanner, // Base64 encoded image
          width: 595.28, // Full page width for A4 size
          margin: [0, 0, 20, 20], // Adjust margins as needed
        };
      },
      content: _content,
      styles: {
        textStyle: {
          fontSize: 11,
          lineHeight: 14.52 / 11, // Adjust line height relative to font size
          fontWeight: 400,
          margin: [5, 15, 0, 0], // Margin top of 15px to separate each block
          wordBreak: 'break-word'
        },
        innerTextStyle: {
          fontSize: 11,
          lineHeight: 14.52 / 11, // Adjust line height relative to font size
          fontWeight: 400,
          margin: [0, 5, 0, 5], // Margin top of 15px to separate each block
          wordBreak: 'break-word'
        },
        dynamicTextStyle: {
          fontSize: 11,
          lineHeight: 14.52 / 11, // Adjust line height relative to font size
          fontWeight: 700,
          wordBreak: 'break-word',
          margin: [0, 5, 0, 0] // Margin top of 15px to separate each block
        }

      }
    };

    pdfMake.createPdf(docDefinition).download('Generated-telephone-support.pdf');


    window.gtag('event', 'download_telephone_support', {
      'label': 'Download Telephone Prompt',
      'screen_name': 'Telephone Prompt',
      'value': 'Download'
    });
  }


  const emailClick = () => {
    setEmailModal(true);
  }



  const print = () => {
    const printWindow = window.open('', '', 'width=800,height=600');
    printWindow.document.write(printContent);
    printWindow.document.title = 'telephone-support'
    printWindow.document.close();
    printWindow.focus();

    const images = printWindow.document.images;
    const totalImages = images.length;
    let loadedImages = 0;

    if (totalImages === 0) {
      printWindow.print();
      printWindow.close();
    } else {
      for (let i = 0; i < totalImages; i++) {
        images[i].onload = () => {
          loadedImages++;
          if (loadedImages === totalImages) {
            printWindow.print();
            printWindow.onafterprint = () => {	

              printWindow.close();
              };
          }
        };
        images[i].onerror = () => {
          loadedImages++;
          if (loadedImages === totalImages) {
            printWindow.print();
            printWindow.close();
          }
        };
      }
    }

    window.gtag('event', 'print_telephone_support', {
      'label': 'Print Telephone Prompt',
      'screen_name': 'Telephone Prompt',
      'value': 'Print'
    });
  }

  const copiedPlainText = `
  <body style="background-color: #fff;">
  
  ${Array.isArray(inputs) && inputs.length > 0 ? `
  <table style="width: 85%; margin: 0 auto; padding: 1.313rem; display: block; background-color: #FAFAFA;" class="prompts-table">
    ${inputs.map(item => `
    <tr style="margin-bottom: 1rem;">
      <td style="vertical-align: top; width: 49%; min-width: 9.375rem;">
        <h3>${item.label}</h3>
      </td>
      <td style="vertical-align: top; width: 49%; min-width: 9.375rem;">
        <p>${item.value}</p>
      </td>
    </tr>
    `).join('')}
  </table>
  ` : ''}
  
</body>
  `

  const copyToClipboard = () => {
    const type = "text/html";
    const blob = new Blob([copiedPlainText], { type });
    const data = [new ClipboardItem({ [type]: blob })];

    window.gtag('event', 'copy_telephone_support', {
      'label': 'Copy Telephone Prompt',
      'screen_name': 'Telephone Prompt',
      'value': 'Copy'
    });
    
    navigator.clipboard.write(data)
      .then(() => {
        toastMessage('Copied to the clipboard');
      })
      .catch(err => {
        console.error('Failed to copy: ', err);
      });
  };

  return (
    <div className='bg-cream telePhoneContainer'>
      <div className="container bg-white">
        <BackToAction link={"/get-advice/letter-builder"} />
        <div className='content-container col-12 col-md-12'>
       
          <h3 className='title-26 black'>Telephone support</h3>
          <div className='d-flex justify-content-between mt-4'>
          <p className='text-normal black col-12 col-md-7 col-lg-8 descp-text'>As your recommendation was to make a telephone call, you can use these prompts to be clear about your expectations on resolving the issue.</p>
          <div className='d-flex col-3 col-mb-3 col-lg-3 d-none d-md-flex justify-content-end'>
          <button className='smallButton text-16-bold'
                  onClick={() => downloadClick()}
                >
                  Download
                </button>
                <button className='smallButton text-16-bold'
                  onClick={() =>copyToClipboard()}
                >
                  Copy
                </button>
                <button className='smallButton text-16-bold' onClick={() => emailClick()}>
                   Email
                </button>
                <button className='smallButton text-16-bold'
                  onClick={() => print()}
                >
                  Print
                </button>
        </div>
        </div>
          {warning ? (
            <div className='mb-3'>
              <ErrorMessage message="If you are in immediate danger you should contact the police on 999." link="" />
            </div>
            ) : null}
            {isInformationContentVisible &&
          <InformationContent title="We do not store any of this data or send anything on your behalf" description="The following notes you make are purely for your own use, we do not save these or send them anywhere on your behalf. You will be able to print and download your notes for your own records. " />
            }
          <TopTip templateType={location.state !== null && location.state.telephoneKey !== undefined ? location.state.telephoneKey : templateKey !== '' ? templateKey : ''} toolsData= {templeteData[templateKey]?.tooltipsData} />
        </div>
       
        <div className='firstQuestionSet content-container mb-4'>
         
          {inputs.map(input => {
            if (input.type !== 'ck-editor') {
              return (<CustomInput
                _key={input.id}
                label={input.label}
                type={input.type}
                _className={input._className}
                value={input.value}
                onChange={e => handleInputChange(input.id, e)}
                placeholder={input.placeholder}
                isValid={input.isValid}
              />)
            } else {
              return (
                <div className='ck-editor-container mt-4'>
                  <h3 className='text-tittle-19 mb-0'>{input.label}</h3>
                  <p dangerouslySetInnerHTML={{__html: input.description}} />
                  <CustomCKEditor
                    placeholder={input.value !== "" ? "" : input.placeholder}
                    value={input.value}
                    onChange={(data) => handleInputChange(input.id, data)}
                    isValid={input.isValid}
                  />
                </div>

              )
            }
          }


          )}
         
        </div>
        <div className='d-flex col-12 d-flex d-md-none mt-4 justify-content-between' role="group" aria-label="Document actions">
              <button className='smallButton text-16-bold'
                onClick={() => downloadClick()}
                aria-label="Download document"
                style={{ flexBasis: '22%', margin: 0 }}>
                Download
              </button>
              <button className='smallButton text-16-bold'
                onClick={() => copyToClipboard()}
                aria-label="Copy to clipboard"
                style={{ flexBasis: '22%', margin: 0 }}>
                Copy
              </button>
              <button className='smallButton text-16-bold'
                onClick={() => emailClick()}
                aria-label="Email document"
                style={{ flexBasis: '22%', margin: 0 }}>
                Email
              </button>
              <button className='smallButton text-16-bold'
                onClick={() => print()}
                aria-label="Print document"
                style={{ flexBasis: '22%', margin: 0 }}>
                Print
              </button>
            </div>
        <div className='d-flex justify-content-between buttonContainer'>
          <button className='discardButton square border border-2 rounded text-20' onClick={() => discardChsnges()} aria-label="Clear all fields">Clear all</button>
          <button className='generateButton text-20' onClick={() => goToPromptsPage()} aria-label="Generate check list">
          Generate check list
            <img src={right_arrow} alt="" aria-hidden="true" style={{ height: '1rem', width: '0.9rem', marginLeft: '1.5rem', verticalAlign: 'middle' }} />
          </button>
        </div>
        <WarningModal title="Warning message" show={showModal} buttonText="I agree, generate check list"
          onClose={e => onClose(e)} onSubmit={() =>{
            setData('inputFields', inputs);
            setData('telephoneKey', templateKey);
            // setData('issueFields', issueInputs)
            // setData('outComeFields', outcomeInput)
            navigate('/get-advice/telephone-prompts', { state: { data: inputs, templateType :location.state !== null && location.state.telephoneKey !== undefined ? location.state.telephoneKey : templateKey !== '' ? templateKey : ''}  })
          }} />
      </div>
      <ToastContainer />

      <EmailModal
        show={emailModal}
        type={"telephone"}
        onHide={() => setEmailModal(false)}
        htmlContent={htmlContent}
        title={"Please provide your email address so we can send your summary"}
      />

    </div>
  )
}

export default TelephoneSupportContainer;